import React, { Component } from "react"
import "./Shelf.scss";

import ShelfImg from "./img/Shelf.svg"

import { withTranslation } from 'react-i18next'

class Shelf extends Component {
    render() {
        return (
          <ul>
            <li
                id={"Shelf_"+this.props.id}
                className="Shelf">
                <img src={ShelfImg} aria-label={this.props.t('Laboratory shelf')}/>
            </li>
          </ul>
        )
    }
}
export default withTranslation()(Shelf);
